export function useCardContextValue({ selectableA11yProps }) {
    return {
        selectableA11yProps
    };
}
